import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import aboutIQAC_Doc_data from '../../Assets/JSON/IQAC/aboutIQAC.json'
import { Button, Box, Typography, Container } from '@mui/material'
import { IMAGE_BASE_PATH_DBRALC } from '../../Config/Config.js'
import { Worker, Viewer } from '@react-pdf-viewer/core'

const IQACPDFViewer = () => {
  const [selectedDocData, setSelectedDocData] = useState(null)
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const filteredData = aboutIQAC_Doc_data.documents?.find(
      (docdata) => docdata.id === String(id) // Ensure type matching
    )
    setSelectedDocData(filteredData)
  }, [id])

  const handleBackClick = () => {
    navigate(-1)
  }

  const fileUrl = selectedDocData?.fileUrl?.[0]
  const workerUrl = new URL(
    'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js',
    import.meta.url
  ).toString()

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Button variant="contained" onClick={handleBackClick}>
        Go Back
      </Button>
      {selectedDocData ? (
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="h5">{selectedDocData.filename}</Typography>
          <Box sx={{ height: { xs: '300px', md: '500px' }, width: '100%' }}>
            {fileUrl ? (
              <Worker workerUrl={workerUrl}>
                <Viewer
                  key={fileUrl}
                  fileUrl={IMAGE_BASE_PATH_DBRALC + fileUrl}
                  defaultScale={1}
                />
              </Worker>
            ) : (
              <Typography color="error">Invalid PDF file.</Typography>
            )}
          </Box>
        </Box>
      ) : (
        <Typography color="error">No data found.</Typography>
      )}
    </Container>
  )
}

export default IQACPDFViewer
